/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2021, Bulb Inc.  For more information, please email contact@hellobulb.com.
 */

/**
 * @module bulb-block-alignment/bulbblockalignmentediting
 */

import { Plugin } from 'ckeditor5';
import BulbBlockAlignmentCommand from './bulbblockalignmentcommand';
import { viewToModelStyleAttribute, modelToViewStyleAttribute } from './converters';
import { normalizeAlignmentOptions } from './utils';
import { blockAlignment } from '../../editorcustomconfig.constant';

/**
 * The block alignment engine plugin. It sets the default configuration, creates converters and registers
 * the alignment plugin.
 *
 * @extends Plugin
 */
export default class BulbBlockAlignmentEditing extends Plugin {

  /**
   * @inheritDoc
   */
  public static get pluginName() {
    return 'BulbBlockAlignmentEditing' as const;
  }

  /**
   * @inheritDoc
   */
  public init(): void {
    const { editor } = this;
    const { data } = editor;
    const { editing } = editor;

    // Define default configuration.
    const configuredOptions = blockAlignment.options;
    editor.config.define('blockAlignment.options', configuredOptions.concat(['full', 'side']));

    // Get configuration.
    const options = normalizeAlignmentOptions(editor.config.get('blockAlignment.options') as any);

    // Converters for imageStyle attribute from model to view.
    const modelToViewConverter = modelToViewStyleAttribute(options, editor);
    editing.downcastDispatcher.on('attribute:blockAlignment', modelToViewConverter);
    data.downcastDispatcher.on('attribute:blockAlignment', modelToViewConverter);

    // Converter for figure element from view to model.
    data.upcastDispatcher.on('element:figure', viewToModelStyleAttribute(options), { priority: 'low' });

    // Register imageStyle command.
    editor.commands.add('blockAlignment', new BulbBlockAlignmentCommand(editor, options));
  }
}
